import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import EkoChoiceElement from "@/utilities/choice-element";
import { cn } from "@/utilities/css";
import style from "./toggle.css?inline";
import "@/components/field/hint";
import "@/components/label";

@customElement("eko-toggle")
export class Toggle extends EkoChoiceElement {
  static styles = [...EkoChoiceElement.styles, unsafeCSS(style)];
  protected validationMessage: string = "Please toggle this switch if you want to proceed.";

  @property({ reflect: true, type: Boolean }) admin: boolean = false;
  @property() class: string = "";
  @property() id: string = `toggle-${Math.random().toString(36).substr(2, 9)}`;
  @property({ reflect: true }) size: "md" | "lg" = "md";
  @property({ reflect: true }) theme: "danger" | "default" = "default";

  render() {
    return html`<div class=${cn("eko-toggle", this.class)} part="root">
      <label class="eko-toggle__label" part="label">
        <span class="eko-toggle__wrapper" part="wrapper">
          <input
            ${ref(this.inputRef)}
            type="checkbox"
            role="switch"
            id=${this.id}
            ?checked=${this.checked}
            @change=${this.handleChange}
            @focus=${this.handleFocus}
            @blur=${this.handleBlur}
            name=${this.name}
            ?required=${this.required}
            value=${this.value}
            ?disabled=${this.disabled}
            class="eko-toggle__input"
            part="input" />
          <span class="eko-toggle__thumb" part="thumb"></span>
        </span>
        ${this.label
          ? html`<eko-label ?required=${this.required} ?admin=${this.admin} as="p"
              >${this.label}</eko-label
            >`
          : nothing}
      </label>
      ${this.hint ? html`<eko-hint>${this.hint}</eko-hint>` : nothing}
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-toggle": Toggle;
  }
}

export default Toggle;
